import React from 'react'
import './tech.css'
import techs from '../../assets/techs.js'

const Technologies = () => {
    return (
        <div className="tech-hero">
            <div className="page-title">Technologies</div>

            <div className="techs-container">
                {techs.map((tech) => (

                    <div className="tech">
                        <div className="tech-left">
                            <div className="tech-name">{tech[0]}</div>
                            <div className="tech-progress" style={{ width: `${tech[1] / 3 * 100}%` }}></div>
                        </div>
                        <div className="tech-right">
                            {tech[1] == 3 && 'Advanced'}
                            {tech[1] == 2 && 'Intermediate'}
                            {tech[1] == 1 && 'Beginner'}
                        </div>
                    </div>

                ))}
            </div>
        </div>
    )
}

export default Technologies